import { Component } from "@angular/core";

@Component({
    standalone: false,
    selector: 'lh-footer',
    templateUrl: './lh-footer.component.html',
    styleUrls: ['./lh-footer.component.scss'],
})
export class LhFooterComponent {
    constructor() { }
}